import dateTimeFormat from "@/core/filters/dateTimeFormat.filter";
import { HOME } from "@/core/api";
import { apiHelper } from "@/core/utils";
import {
  LOADING_OPEN_LOADING,
  LOADING_CLOSE_LOADING,
} from "@/core/store/loading.module";

/* Define Module Name */
const MODULE_NAME = "home/";

/* Define Action Name */
const A_GET_APPS = "getApps";
const A_EXPORT_APP_EXCEL = "exportAppsExcel";

/* Define Reset State Action Name */
const A_INITIAL_GET_APPS_STATE = "initialGetAppsState";
const A_INITIAL_EXPORT_APP_EXCEL_STATE = "initialExportAppsExcelState";

/* Define Getter Name */

/* Define Mutation Name */
const M_APPS = "setApps";
const M_EXPORT_APP_EXCEL = "setExportAppsExcel";

/* Define Reset State Mutation Name */
const M_INITIAL_GET_APPS_STATE = "setInitialGetAppsState";
const M_INITIAL_EXPORT_APP_EXCEL_STATE = "setInitialExportAppsExcelState";

/* Define Export Name */
export const HOME_GET_APPS = MODULE_NAME + A_GET_APPS;
export const HOME_EXPORT_APP_EXCEL = MODULE_NAME + A_EXPORT_APP_EXCEL;

/* Define Reset State Name */
export const HOME_INITIAL_GET_APPS_STATE =
  MODULE_NAME + A_INITIAL_GET_APPS_STATE;
export const HOME_INITIAL_EXPORT_APP_EXCEL_STATE =
  MODULE_NAME + A_INITIAL_EXPORT_APP_EXCEL_STATE;

const state = {
  apps: {
    code: 0,
    complete: false,
    data: null,
    message: null,
    pagination: {
      currentPage: 0,
      total: 0,
      pageSize: 0,
      lastPage: 0,
    },
  },
  exportAppsExcel: {
    code: 0,
    complete: false,
    data: null,
    message: null,
  },
};

//Getters
const getters = {};

// Actions
const actions = {
  [A_GET_APPS]({ dispatch, commit }, { data }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    HOME.getAppsList(data)
      .then((response) => {
        result = response;
        commit(M_APPS, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_APPS, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_EXPORT_APP_EXCEL]({ dispatch, commit }) {
    dispatch(`${LOADING_OPEN_LOADING}`, null, { root: true });
    let result = null;
    HOME.exportAppsExcel()
      .then((response) => {
        result = response;
        commit(M_EXPORT_APP_EXCEL, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      })
      .catch((error) => {
        result = error;
        commit(M_EXPORT_APP_EXCEL, result);
        dispatch(`${LOADING_CLOSE_LOADING}`, null, { root: true });
      });
  },
  [A_INITIAL_GET_APPS_STATE]({ commit }) {
    commit(M_INITIAL_GET_APPS_STATE);
  },
  [A_INITIAL_EXPORT_APP_EXCEL_STATE]({ commit }) {
    commit(M_INITIAL_EXPORT_APP_EXCEL_STATE);
  },
};

// Mutations
const mutations = {
  [M_APPS](state, result) {
    if (result.code === 200) {
      let d = result.data;
      let p = result.pagination;
      state.apps = {
        code: result.code,
        complete: true,
        data: d.map((x, index) => {
          return {
            no: index + 1,
            accountName: x.accountName,
            appName: x.appName,
            argoURL: x.argoURL,
            availabilityZone: x.availabilityZone,
            createBy: x.createBy,
            createTime: x.createTime,
            createUser: x.createUser,
            env: x.env,
            publicHybrid: x.l1Dir,
            businessUnit: x.l2Dir,
            logId: x.logId,
            params: x.params,
            region: x.region,
            remark: x.remark,
            searchValue: x.searchValue,
            status: x.status,
            subnet: x.subnet,
            updateBy: x.updateBy,
            updateTime: x.updateTime,
          };
        }),
        message: null,
        pagination: {
          currentPage: p.current_page,
          total: p.total,
          pageSize: p.page_size,
          lastPage: p.last_page,
        },
      };
      apiHelper.checkToken();
    } else {
      state.apps = {
        code: result.code,
        complete: true,
        data: null,
        message: apiHelper.sortOutMessage(result.msg),
        pagination: {
          currentPage: 0,
          total: 0,
          pageSize: 0,
          lastPage: 0,
        },
      };
    }
  },
  [M_EXPORT_APP_EXCEL](state, result) {
    state.exportAppsExcel = {
      code: 0,
      complete: true,
      data: result,
      message: apiHelper.sortOutMessage(result.msg),
    };
  },
  [M_INITIAL_GET_APPS_STATE](state) {
    state.apps = {
      code: 0,
      complete: false,
      data: null,
      message: null,
      pagination: {
        currentPage: 0,
        total: 0,
        pageSize: 0,
        lastPage: 0,
      },
    };
  },
  [M_INITIAL_EXPORT_APP_EXCEL_STATE](state) {
    state.exportAppsExcel = {
      code: 0,
      complete: false,
      data: null,
      message: null,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
